import * as React from 'react';

interface Value {
	errorMessage: React.ReactNode;
	fallback?(): React.ReactNode;
	handler?(error: any, errorInfo?: React.ErrorInfo): React.ReactNode; // tslint:disable-line: no-any
	onError(error: any): void; // tslint:disable-line: no-any
	onUserError(errorMessage: React.ReactNode): void;
}

export const Context = React.createContext<Value>({
	errorMessage: null,
	onError: () => {},
	onUserError: () => {},
});
Context.displayName = 'ErrorHandler.Context';

export const useErrorHandler = () => React.useContext(Context);

export const ErrorConsumer: React.FunctionComponent<{ children(errorMessage: React.ReactNode): React.ReactNode }> = ({
	children,
}) => {
	const { errorMessage } = useErrorHandler();
	return <>{errorMessage !== null ? children(errorMessage) : null}</>;
};
ErrorConsumer.displayName = 'ErrorHandler.ErrorConsumer';
